import { DialogueBubbleIcon, UsersIcon } from '@honestica/curecall-ui'
import Sidebar from 'src/components/navigation/sidebar.component'
import { useTranslation } from 'react-i18next'
import { TMenuTab } from 'src/components/navigation/sidebar-tabs.component'
import { useCurrentProject } from 'src/providers/current-project.provider'

const HrSidebar = () => {
  const { t } = useTranslation()
  const { project } = useCurrentProject()

  const hrMenuTabs: TMenuTab[] = [
    {
      path: `/${project.id}/hr/contacts`,
      label: t('components.navigation.hr-contacts'),
      IconComponent: UsersIcon,
    },
    {
      path: `/${project.id}/hr/campaigns`,
      label: t('components.navigation.hr-campaigns'),
      IconComponent: DialogueBubbleIcon,
    },
  ]

  return <Sidebar menuTabs={hrMenuTabs} backgroundClass="c-bg-gradient-rh" />
}

export default HrSidebar
